import React from "react";
import { useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { toggleDrawer } from "../../../redux/drawer";
import Backdrop from "../../UI/Backdrop/Backdrop";
import Icons from "../../UI/Icon/Icon";
import Icon from "../../UI/Icon/Icon";
import classes from "./Drawer.module.scss";

const LINKS = [
  { link: "/home", text: "Home", icon: "home" },
  { link: "/customers", text: "Customers", icon: "avatar" },
  { link: "/zones", text: "Zones", icon: "squares" },
  { link: "/cashier", text: "Cashier", icon: "coin" },
  { link: "/orders", text: "Orders", icon: "bag" },
  { link: "/reports", text: "Reports", icon: "clock" },
  { link: "/settings", text: "Settings", icon: "settings" },
];

const Drawer = ({ show }) => {
  const dispatch = useDispatch();

  const toggleDrawerHandler = () => {
    dispatch(toggleDrawer());
  };

  let drawer = null;
  if (show) {
    drawer = (
      <div className={classes.Drawer}>
        <Backdrop type="dark" onClicked={toggleDrawerHandler} />
        <button onClick={toggleDrawerHandler} className={classes.ToggleButton}>
          <Icons name="cross-2" width={2.4} height={2.4} />
        </button>
        <nav>
          <ul>
            {LINKS.map((link) => {
              return (
                <li key={link.link}>
                  <NavLink
                    to={{ pathname: link.link }}
                    className={(navData) => {
                      return navData.isActive
                        ? classes.ActiveLink
                        : classes.Link;
                    }}
                  >
                    <Icon name={link.icon} />
                    <span className={classes.LinkText}>{link.text}</span>
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>
    );
  }
  return drawer;
};

export default Drawer;
